import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { ONBOARDING_API } from "../apiRoutes";

interface UseGetBulkUploadHistoryProps {
  communityId: string;
  data: any;
  queryKey?: any[];
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

// One row per uploaded owner file (VALIDATED = never committed, COMMITTED = imported)
const getBulkUploadHistory = async (communityId: string, data: any) =>
  await axiosAuth.post(`${ONBOARDING_API(communityId)}/occupancy/uploads/grid`, data);

const useGetBulkUploadHistory = ({
  communityId,
  data,
  queryKey = [],
  queryParams,
}: UseGetBulkUploadHistoryProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["owner-bulk-upload-history", communityId, ...queryKey],
    queryFn: () => getBulkUploadHistory(communityId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetBulkUploadHistory;
